import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyCoupons } from '@components/templates';
import { SITE_URLS } from '@constants';
import { useSEOMetatags } from '@hooks/useSEOMetatags';
import { FiltersProvider } from '@context';

export function MyCouponsPage() {
    const { t } = useTranslation();

    const translations = {
        title: t('my-coupons-component.metatags.title'),
        description: t('my-coupons-component.metatags.description'),
    };

    useSEOMetatags({
        title: translations.title,
        description: translations.description,
        url: SITE_URLS.myCoupons,
        index: false,
    });

    return (
        <FiltersProvider>
            <MyCoupons />
        </FiltersProvider>
    );
}
